import { Link } from "react-router-dom";
import Logo from "./Logo";
import { serviceNav } from "@/data/services";

const nav = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/how-we-work", label: "How We Work" },
  { to: "/industries", label: "Industries" },
  { to: "/insights", label: "Insights" },
  { to: "/careers", label: "Careers" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0B1F3A] text-white" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 md:grid-cols-2 lg:grid-cols-4 lg:px-8">
        <div>
          <Logo dark />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
            Senior delivery, PMO and resourcing for regulated programmes.
          </p>
          <div className="mt-4 flex flex-wrap gap-2" data-testid="footer-badges">
            <span className="rounded-full border border-[#C9A227]/40 px-3 py-1 text-[11px] font-semibold text-[#C9A227]">100% Black-owned</span>
            <span className="rounded-full border border-[#C9A227]/40 px-3 py-1 text-[11px] font-semibold text-[#C9A227]">B-BBEE Level 1</span>
          </div>
        </div>
        <nav aria-label="Footer">
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-[#C9A227]">Navigate</h3>
          <ul className="mt-4 space-y-2.5">
            {nav.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="text-sm text-white/70 transition-colors hover:text-white" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-[#C9A227]">Services</h3>
          <ul className="mt-4 space-y-2.5">
            {serviceNav.map((s) => (
              <li key={s.slug}>
                <Link to={`/services/${s.slug}`} className="text-sm text-white/70 transition-colors hover:text-white" data-testid={`footer-service-${s.slug}`}>
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-xs font-bold uppercase tracking-[0.2em] text-[#C9A227]">Contact</h3>
          <ul className="mt-4 space-y-2.5 text-sm text-white/70" data-testid="footer-contact-details">
            <li>Email: <a href="mailto:takunda.noha@incrementalconsulting.co.za" className="transition-colors hover:text-white" data-testid="footer-email-link">takunda.noha@incrementalconsulting.co.za</a></li>
            <li>Phone: <a href="tel:+27608249449" className="transition-colors hover:text-white" data-testid="footer-phone-link">+27 60 824 9449</a></li>
            <li>Fourways, Johannesburg, South Africa</li>
            <li className="text-white/50">Incremental Consulting (Pty) Ltd<br />Reg. 2023/004592/07</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 py-5 text-xs text-white/50 lg:px-8">
          © 2026 Incremental Consulting (Pty) Ltd · Reg. 2023/004592/07. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
